import {actions} from '../redux/reducers/global/globalSlice'
import {useAppDispatch, useAppSelector} from './useReduxHooks'
import {User} from '../models'
import * as exercicesActions from '../redux/reducers/exercices/slice'
import * as classesActions from '../redux/reducers/classes/slice'
import * as establshementsActions from '../redux/reducers/establishements/slice'
import * as examsActions from '../redux/reducers/exams/slice'
import * as licenesActions from '../redux/reducers/licenses/slice'
import * as remarquesActions from '../redux/reducers/remarques/slice'
import * as subjectsActions from '../redux/reducers/subjects/slice'
import * as typeExamsActions from '../redux/reducers/typeExams/slice'
import * as typeRemarquesActions from '../redux/reducers/remarques/slice'
import * as usersActions from '../redux/reducers/users/slice'

const useGlobals = () => {
  const dispatch = useAppDispatch()
  const {kid, actifQrCodeCamera} = useAppSelector((state) => state.global)

  const onKidUpdate = (kid?: User) => {
    dispatch(actions.kidChanged(kid))
  }

  const activateQrCodeCamera = () => {
    dispatch(actions.activateQrCodeCamera({}))
  }
  const desactivateQrCodeCamera = () => {
    dispatch(actions.desactivateQrCodeCamera({}))
  }

  const resetStore = () => {
    dispatch(actions.resetGlobal())
    dispatch(classesActions.actions.resetClasses())
    dispatch(establshementsActions.actions.resetEstablishements())
    dispatch(examsActions.actions.resetExams())
    dispatch(exercicesActions.actions.resetExercices())
    dispatch(licenesActions.actions.resetLicenses())
    dispatch(remarquesActions.actions.resetRemarques())
    dispatch(subjectsActions.actions.resetSubjects())
    dispatch(typeExamsActions.actions.resetTypeExams())
    dispatch(typeRemarquesActions.actions.resetRemarques())
    dispatch(usersActions.actions.resetUsers())
  }

  return {
    resetStore,
    kid,
    onKidUpdate,
    activateQrCodeCamera,
    desactivateQrCodeCamera,
    actifQrCodeCamera,
  }
}

export default useGlobals
